<template>
  <div>
    <img src="@/assets/logo-alt.svg" />
  </div>
</template>

<script>
export default {
  name: 'Sandbox'
}
</script>
